// Server-aligned package catalog (display-only). Prices are enforced by backend.
export const PACKAGE_GROUPS = [
  {
    id: "web",
    title: "Web Development",
    description: "Custom business websites, landing pages, and lead-gen sites.",
    packages: [
      {
        id: "web_starter",
        name: "Starter Website",
        price: "$499",
        startingAt: true,
        features: [
          "Up to 3 pages",
          "Mobile responsive design",
          "Contact form",
          "Basic SEO setup",
          "SSL setup",
          "Lead capture form",
        ],
      },
      {
        id: "web_business",
        name: "Business Website",
        price: "$999",
        recommended: true,
        startingAt: true,
        features: [
          "Up to 7 pages",
          "Custom design",
          "Service pages",
          "Lead-generation forms",
          "SEO structure",
          "Blog/CMS functionality",
        ],
      },
      {
        id: "web_premium",
        name: "Premium Website",
        price: "$1,499",
        startingAt: true,
        features: [
          "8+ pages",
          "Advanced functionality",
          "Custom integrations",
          "Booking or payment setup",
          "CMS included",
          "SEO-friendly structure",
        ],
      },
    ],
  },
  {
    id: "app",
    title: "Web & Mobile App Development",
    description: "Custom apps and tools beyond a basic website.",
    packages: [
      {
        id: "app_mvp",
        name: "MVP App Package",
        price: "$2,500",
        startingAt: true,
        features: [
          "User authentication",
          "Dashboard",
          "Responsive web app",
          "Database setup",
          "Basic admin tools",
        ],
      },
      {
        id: "app_business",
        name: "Business App Package",
        price: "$5,000",
        recommended: true,
        startingAt: true,
        features: [
          "Custom workflows",
          "API integrations",
          "User roles",
          "Analytics dashboard",
          "Admin dashboard",
        ],
      },
    ],
  },
  {
    id: "crm",
    title: "Custom CRM",
    description: "Lead tracking, sales pipelines, and internal business tools.",
    packages: [
      {
        id: "crm_starter",
        name: "CRM Starter",
        price: "$2,000",
        startingAt: true,
        features: [
          "Contact management",
          "Lead tracking",
          "Task management",
          "Basic reporting",
        ],
      },
      {
        id: "crm_pro",
        name: "CRM Pro",
        price: "$5,000",
        recommended: true,
        startingAt: true,
        features: [
          "Sales pipeline",
          "Automation workflows",
          "Team management",
          "Reporting dashboards",
          "Custom permissions",
        ],
      },
    ],
  },
  {
    id: "cms",
    title: "CMS Software",
    description: "Update pages, blogs, services and content without a developer.",
    packages: [
      {
        id: "cms_starter",
        name: "CMS Starter",
        price: "$1,500",
        startingAt: true,
        features: ["Editable pages", "Media library", "User roles", "Lightweight admin"],
      },
      {
        id: "cms_business",
        name: "CMS Business",
        price: "$3,500",
        recommended: true,
        startingAt: true,
        features: ["Blog + portfolio", "Custom modules", "SEO tools", "Multi-author workflow"],
      },
      {
        id: "cms_enterprise",
        name: "Enterprise CMS",
        price: "Custom Quote",
        custom: true,
        features: ["Multi-site", "Granular permissions", "Advanced workflow", "SLA"],
      },
    ],
  },
  {
    id: "api",
    title: "API Integration",
    description: "Connect to Stripe, CRMs, booking systems, email, databases.",
    packages: [
      {
        id: "api_single",
        name: "Single API Integration",
        price: "$500",
        startingAt: true,
        features: ["1 third-party API", "Auth + error handling", "Docs"],
      },
      {
        id: "api_multi",
        name: "Multi-System Integration",
        price: "$1,500",
        recommended: true,
        startingAt: true,
        features: ["Multiple APIs", "Webhook handling", "Data syncing", "Monitoring"],
      },
      {
        id: "api_enterprise",
        name: "Enterprise Integration",
        price: "Custom Quote",
        custom: true,
        features: ["Complex pipelines", "Custom middleware", "Scaling + SLA"],
      },
    ],
  },
  {
    id: "ai",
    title: "AI Integration",
    description: "Chatbots, automation workflows, AI-powered customer support.",
    packages: [
      {
        id: "ai_starter",
        name: "AI Starter",
        price: "$750",
        startingAt: true,
        features: [
          "Chatbot integration",
          "AI assistant setup",
          "Lead capture automation",
        ],
      },
      {
        id: "ai_business",
        name: "AI Business",
        price: "$2,500",
        recommended: true,
        startingAt: true,
        features: [
          "Workflow automation",
          "CRM integration",
          "AI-powered customer support",
        ],
      },
      {
        id: "ai_enterprise",
        name: "Enterprise AI",
        price: "Custom Quote",
        custom: true,
        features: ["Custom models", "Advanced workflows", "Dedicated support"],
      },
    ],
  },
];

export const HOSTING_PLANS = [
  {
    id: "host_starter",
    name: "Equinox Hosting Basic",
    price: "$29",
    suffix: "/month",
    features: ["Secure hosting", "SSL certificate", "Daily backups", "Security monitoring"],
  },
  {
    id: "host_business",
    name: "Equinox Hosting Business",
    price: "$59",
    suffix: "/month",
    recommended: true,
    features: [
      "Everything in Basic",
      "Priority support",
      "Performance monitoring",
      "Monthly reporting",
    ],
  },
  {
    id: "host_premium",
    name: "Equinox Hosting Premium",
    price: "$99",
    suffix: "/month",
    badge: "Maintenance Included",
    features: [
      "Everything in Business",
      "Enhanced security",
      "Priority response",
      "Advanced monitoring",
      "FREE maintenance included",
    ],
  },
];
